"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

require("core-js/modules/es.object.define-property.js");

var _defineProperty2 = require("@babel/runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = require("@babel/runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

require("core-js/modules/es.array.reduce.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.string.includes.js");

require("core-js/modules/es.array.every.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.array.find.js");

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.object.assign.js");

require("core-js/modules/web.timers.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

var _optionProcessor = require("../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor");

var _optionProcessor2 = _interopRequireDefault(_optionProcessor);

var _core = require("@mpxjs/core");

var _webxJs = require("@didi/webx-js");

var _feCoupon = require("@didi/fe-coupon");

var _util = require("../../lib/js/util");

function _interopRequireDefault(obj) {
    try {
        return obj && obj.__esModule ? obj : { default: obj };
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('_interopRequireDefault@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}

function ownKeys(object, enumerableOnly) {
    try {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            enumerableOnly && (symbols = symbols.filter(function func_trir_e6f9dcb162ddc91bed10b034c2858b85(sym) {
                try {
                    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                } catch (e)
                                        {
                        'use strict';
                        var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                            try {
                                JSON.stringify(k);
                                return true;
                            } catch (e) {
                                return false;
                            }
                        });
                        window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_e6f9dcb162ddc91bed10b034c2858b85@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                            stack: e.stack,
                            arguments: omegaParams
                        }) : '';
                        throw e;
                    }
            })), keys.push.apply(keys, symbols);
        }
        return keys;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('ownKeys@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}

function _objectSpread(target) {
    try {
        for (var i = 1; i < arguments.length; i++) {
            var source = null != arguments[i] ? arguments[i] : {};
            i % 2 ? ownKeys(Object(source), !0).forEach(function func_trir_c0676a94f483fe5106ed726722866000(key) {
                try {
                    (0, _defineProperty3.default)(target, key, source[key]);
                } catch (e)
                                        {
                        'use strict';
                        var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                            try {
                                JSON.stringify(k);
                                return true;
                            } catch (e) {
                                return false;
                            }
                        });
                        window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_c0676a94f483fe5106ed726722866000@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                            stack: e.stack,
                            arguments: omegaParams
                        }) : '';
                        throw e;
                    }
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function func_trir_b76604ff2c09d1b25f9e26fd3e3dbe8a(key) {
                try {
                    Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                } catch (e)
                                        {
                        'use strict';
                        var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                            try {
                                JSON.stringify(k);
                                return true;
                            } catch (e) {
                                return false;
                            }
                        });
                        window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_b76604ff2c09d1b25f9e26fd3e3dbe8a@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                            stack: e.stack,
                            arguments: omegaParams
                        }) : '';
                        throw e;
                    }
            });
        }
        return target;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('_objectSpread@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var wxsModules = {};
global.currentSrcMode = "wx";

var couponTypeDict = {
  cash: [3],
  discount: [100, 111],
  pass: [103]
};
(0, _core.createComponent)({
  name: 'resultPage',
  properties: {
    isH5: {
      type: Boolean,
      value: false
    },
    isHide: {
      type: Boolean,
      value: false
    },
    isAutoJump: {
      type: Boolean,
      value: false
    },
    autoReceive: {
      type: Boolean,
      value: false
    },
    buttonConfig: {
      type: Object,
      value: function value() {
    try {
        return {};
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('value@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}
    },
    couponCollection: {
      type: Object,
      value: function value() {
    try {
        return {
            coupon: [],
            business_coupon: []
        };
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('value@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}
    },
    activityInfo: {
      type: Object,
      value: function value() {
    try {
        return {
            is_new_customer: false,
            new_info: [],
            new_customer_info: {
                coupon_info: [],
                ecom_info: []
            },
            customer_info: {
                coupon_info: [],
                ecom_info: []
            }
        };
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('value@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}
    }
  },
  computed: {
    // 领取结果类型: 1 新用户单张券、2 新用户券包、3 新用户券包有待过期、4 老用户单张券、5 老用户券包 6、商家券包 7、任务类型
    resultType: function resultType() {
    try {
        var type = 5;
        if (this.taskCouponList.length) {
            type = 7;
        } else if (this.onlyEcomInfo) {
            type = 6;
        } else if (this.normalCouponList.length) {
            if (this.normalCouponList.length === 1)
                type = 4;
            else
                type = 5;
        } else if (this.energyCouponList.length) {
            if (this.energyCouponList.length === 1)
                type = 4;
            else
                type = 5;
        }
        return type;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('resultType@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    onlyEcomInfo: function onlyEcomInfo() {
    try {
        return this.normalCouponList.length === 0 && this.merchantCouponList.length > 0;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('onlyEcomInfo@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    includesEcomInfo: function includesEcomInfo() {
    try {
        return this.merchantCouponList.length > 0;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('includesEcomInfo@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    resultMainTitle: function resultMainTitle() {
    try {
        var text = '';
        switch (this.resultType) {
        case 1:
            text = '新人专享优惠券';
            break;
        case 4:
            text = '出行优惠券';
            break;
        case 7:
            text = '顺风车车主任务券';
            break;
        default:
            break;
        }
        return text;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('resultMainTitle@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    // 券面值加和
    couponPackage: function couponPackage() {
    try {
        var totalPrice = this.couponList.reduce(function func_trir_e31bda73e0e9df61a482a21f6af2ab72(sum, coupon) {
            try {
                if (coupon.source_type === 'normal') {
                    if (couponTypeDict.cash.includes(coupon.couponType)) {
                        sum += coupon.couponAmt;
                    } else if (couponTypeDict.discount.includes(coupon.couponType)) {
                        sum += coupon.couponMaxAmt;
                    } else if (couponTypeDict.pass.includes(coupon.couponType)) {
                        sum += (coupon.amount - coupon.v_amount) / 100;
                    }
                }
                if (coupon.source_type === 'energy') {
                    sum += coupon.couponAmt;
                }
                return sum;
            } catch (e)
                                {
                    'use strict';
                    var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                        try {
                            JSON.stringify(k);
                            return true;
                        } catch (e) {
                            return false;
                        }
                    });
                    window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_e31bda73e0e9df61a482a21f6af2ab72@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                        stack: e.stack,
                        arguments: omegaParams
                    }) : '';
                    throw e;
                }
        }, 0);
        return (0, _util.toFixedTwo)(totalPrice);
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('couponPackage@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    // TODO 都是现金券标识 待测试
    isAllCashCoupon: function isAllCashCoupon() {
    try {
        var didi = this.couponList.every(function func_trir_fbf4c90e4886a54fdd42b554e84f5dba(coupon) {
            try {
                return coupon.source_type === 'normal';
            } catch (e)
                                {
                    'use strict';
                    var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                        try {
                            JSON.stringify(k);
                            return true;
                        } catch (e) {
                            return false;
                        }
                    });
                    window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_fbf4c90e4886a54fdd42b554e84f5dba@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                        stack: e.stack,
                        arguments: omegaParams
                    }) : '';
                    throw e;
                }
        });
        var energy = this.couponList.every(function func_trir_3acfaa552c7de5040cd76c92d6ecb7c9(coupon) {
            try {
                return coupon.source_type === 'energy';
            } catch (e)
                                {
                    'use strict';
                    var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                        try {
                            JSON.stringify(k);
                            return true;
                        } catch (e) {
                            return false;
                        }
                    });
                    window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_3acfaa552c7de5040cd76c92d6ecb7c9@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                        stack: e.stack,
                        arguments: omegaParams
                    }) : '';
                    throw e;
                }
        });
        return didi || energy;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('isAllCashCoupon@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    // 过期时间
    expire: function expire() {
    try {
        return 1;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('expire@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    // 券列表 length === 1时 使用单张券模式(大券)展示；length > 1时 使用券列表模式(小券)展示
    couponList: function couponList() {
    try {
        var list = [].concat((0, _toConsumableArray3.default)(this.normalCouponList), (0, _toConsumableArray3.default)(this.merchantCouponList), (0, _toConsumableArray3.default)(this.energyCouponList), (0, _toConsumableArray3.default)(this.taskCouponList));
        return list;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('couponList@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    // 普通券列表
    normalCouponList: function normalCouponList() {
    try {
        var _this$couponCollectio;
        var originCoupons = ((_this$couponCollectio = this.couponCollection) === null || _this$couponCollectio === void 0 ? void 0 : _this$couponCollectio.coupon) || [];
        var formatedCoupons = (0, _feCoupon.formatCouponData)(originCoupons, 'didi');
        return formatedCoupons.map(function func_trir_6f890efb70c9228f66adc9312644575b(coupon, index) {
            try {
                var c = _objectSpread(_objectSpread({ source_type: 'normal' }, originCoupons[index]), coupon);
                if (c.type === 103) {
                    c.couponAmt = c.v_amount / 100;
                }
                return c;
            } catch (e)
                                {
                    'use strict';
                    var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                        try {
                            JSON.stringify(k);
                            return true;
                        } catch (e) {
                            return false;
                        }
                    });
                    window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_6f890efb70c9228f66adc9312644575b@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                        stack: e.stack,
                        arguments: omegaParams
                    }) : '';
                    throw e;
                }
        });
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('normalCouponList@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    // 商家券列表
    merchantCouponList: function merchantCouponList() {
    try {
        var _this$couponCollectio2;
        var originCoupons = ((_this$couponCollectio2 = this.couponCollection) === null || _this$couponCollectio2 === void 0 ? void 0 : _this$couponCollectio2.business_coupon) || [];
        var formatedCoupons = (0, _feCoupon.formatCouponData)(originCoupons, 'business');
        return formatedCoupons.map(function func_trir_1f7b78779e3a954b92a4903c905a03a4(coupon, index) {
            try {
                return _objectSpread(_objectSpread({ source_type: 'merchant' }, originCoupons[index]), coupon);
            } catch (e)
                                {
                    'use strict';
                    var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                        try {
                            JSON.stringify(k);
                            return true;
                        } catch (e) {
                            return false;
                        }
                    });
                    window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_1f7b78779e3a954b92a4903c905a03a4@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                        stack: e.stack,
                        arguments: omegaParams
                    }) : '';
                    throw e;
                }
        });
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('merchantCouponList@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    // 能源枪价券
    energyCouponList: function energyCouponList() {
    try {
        var _this$couponCollectio3;
        var originCoupons = ((_this$couponCollectio3 = this.couponCollection) === null || _this$couponCollectio3 === void 0 ? void 0 : _this$couponCollectio3.business_energy) || [];
        var formatedCoupons = (0, _feCoupon.formatCouponData)(originCoupons, 'energy');
        return formatedCoupons.map(function func_trir_c7612c888e2127de7ec4edcb6fb2181a(coupon, index) {
            try {
                return _objectSpread(_objectSpread({ source_type: 'energy' }, originCoupons[index]), coupon);
            } catch (e)
                                {
                    'use strict';
                    var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                        try {
                            JSON.stringify(k);
                            return true;
                        } catch (e) {
                            return false;
                        }
                    });
                    window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_c7612c888e2127de7ec4edcb6fb2181a@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                        stack: e.stack,
                        arguments: omegaParams
                    }) : '';
                    throw e;
                }
        });
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('energyCouponList@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    // 能源枪价券
    taskCouponList: function taskCouponList() {
    try {
        var _this$couponCollectio4;
        var originCoupons = ((_this$couponCollectio4 = this.couponCollection) === null || _this$couponCollectio4 === void 0 ? void 0 : _this$couponCollectio4.car_owner_task) || [];
        var formatedCoupons = (0, _feCoupon.formatCouponData)(originCoupons, 'task');
        return formatedCoupons.map(function func_trir_908bc246b5a17e34b1ff354585e99ce2(coupon, index) {
            try {
                return _objectSpread(_objectSpread({ source_type: 'task' }, originCoupons[index]), coupon);
            } catch (e)
                                {
                    'use strict';
                    var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                        try {
                            JSON.stringify(k);
                            return true;
                        } catch (e) {
                            return false;
                        }
                    });
                    window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_908bc246b5a17e34b1ff354585e99ce2@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                        stack: e.stack,
                        arguments: omegaParams
                    }) : '';
                    throw e;
                }
        });
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('taskCouponList@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    // 是否是单张券
    singleCoupon: function singleCoupon() {
    try {
        return this.couponList.length === 1;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('singleCoupon@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    // 首张券的信息 (单券模式下使用)
    couponInfo: function couponInfo() {
    try {
        return this.couponList[0];
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('couponInfo@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    buttonType: function buttonType() {
    try {
        return this.buttonConfig.buttonType || 'share';
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('buttonType@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    buttonText: function buttonText() {
    try {
        return this.buttonConfig.buttonText || '';
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('buttonText@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    tipText: function tipText() {
    try {
        return this.buttonConfig.tipText || '';
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('tipText@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    // 含有封顶券时隐藏金额
    showAmount: function showAmount() {
    try {
        return !this.couponList.find(function func_trir_43f3aa0d8f8d2487211be17203a89ae8(coupon) {
            try {
                return Number(coupon === null || coupon === void 0 ? void 0 : coupon.couponType) === 123;
            } catch (e)
                                {
                    'use strict';
                    var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                        try {
                            JSON.stringify(k);
                            return true;
                        } catch (e) {
                            return false;
                        }
                    });
                    window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_43f3aa0d8f8d2487211be17203a89ae8@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                        stack: e.stack,
                        arguments: omegaParams
                    }) : '';
                    throw e;
                }
        });
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('showAmount@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}
  },
  watch: {
    /* 监听按钮是否被主动点击 */
    btnHitted: function btnHitted(hit) {
    try {
        if (this.isAutoJump && hit) {
            clearTimeout(this.st);
            this.st = 0;
        }
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('btnHitted@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},

    /* 监听页面是否已经退后台 */
    isHide: function isHide(hide) {
    try {
        if (this.isAutoJump && hide) {
            clearTimeout(this.st);
            this.st = 0;
        }
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('isHide@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}
  },
  methods: {
    handleShare: function handleShare() {
    try {
        if (!this.isMiniprogram)
            this.triggerEvent('action', { type: 'share' });
        var params = {
            ck_type: 1,
            btn_name: this.buttonText
        };
        this.taskDetail.length && (params.task_detail = this.taskDetail);
        this.triggerEvent('trackEvent', {
            type: 'resultPageBtnClick',
            params: params
        });
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('handleShare@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    handleJump: function handleJump() {
    try {
        this.btnHitted = true;
        var trackParams = {
            ck_type: 2,
            btn_name: this.buttonText
        };
        this.taskDetail.length && (trackParams.task_detail = this.taskDetail);
        this.triggerEvent('trackEvent', {
            type: 'resultPageBtnClick',
            params: trackParams
        });
        var params = _objectSpread({ target: 'page' }, this.buttonConfig);
        this.triggerEvent('action', {
            type: 'jump',
            params: params
        });
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('handleJump@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    handleBtnJump: function handleBtnJump() {
    try {
        this.btnHitted = true;
        var params = _objectSpread({ target: 'page' }, this.buttonConfig);
        this.triggerEvent('action', {
            type: 'jump',
            params: params
        });
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('handleBtnJump@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    handleCouponTap: function handleCouponTap(_ref, index) {
    try {
        var detail = _ref.detail;
        var params = detail.params;
        this.triggerEvent('action', {
            type: 'couponTap',
            params: Object.assign({}, params, { index: index })
        });
        var trackParams = {
            batch_id: params.batch_id,
            btn_name: params.buttonText
        };
        this.triggerEvent('trackEvent', {
            type: 'resultPageCouponClick',
            params: trackParams
        });
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('handleCouponTap@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    handleBackToApp: function handleBackToApp() {
    try {
        if (this.isH5)
            return;
        this.triggerEvent('action', { type: 'backToApp' });
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('handleBackToApp@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    handleAutoJump: function handleAutoJump() {
    try {
        var _this = this;
        this.st = setTimeout(function func_trir_95d6daa03c02dd989617741a5444c64a() {
            try {
                var params = _objectSpread({ target: 'page' }, _this.buttonConfig);
                _this.triggerEvent('action', {
                    type: 'jump',
                    params: params
                });
                _this.st = 0;
                _this.st = setTimeout(function func_trir_686b06564bd589aafa4a161712693b0d() {
                    try {
                        if (!_this.isHide) {
                            switch ((0, _webxJs.xenv)()) {
                            case 'passenger':
                                (0, _webxJs.goTo)({ scheme: 'OneTravel://dache_anycar/entrance' });
                                break;
                            case 'wxmp':
                                (0, _webxJs.goTo)({ path: '/home/pages/dache' });
                                break;
                            }
                        }
                        _this.st = 0;
                    } catch (e)
                                                {
                            'use strict';
                            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                                try {
                                    JSON.stringify(k);
                                    return true;
                                } catch (e) {
                                    return false;
                                }
                            });
                            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_686b06564bd589aafa4a161712693b0d@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                                stack: e.stack,
                                arguments: omegaParams
                            }) : '';
                            throw e;
                        }
                }, 3000);
            } catch (e)
                                {
                    'use strict';
                    var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                        try {
                            JSON.stringify(k);
                            return true;
                        } catch (e) {
                            return false;
                        }
                    });
                    window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_95d6daa03c02dd989617741a5444c64a@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                        stack: e.stack,
                        arguments: omegaParams
                    }) : '';
                    throw e;
                }
        }, 3000);
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('handleAutoJump@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}
  },
  data: function data() {
    try {
        return {
            isMiniprogram: __mpx_mode__ === 'wx' || __mpx_mode__ === 'ali',
            isWeb: __mpx_mode__ === 'web',
            st: 0,
            btnHitted: false,
            taskDetail: []
        };
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('data@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
  ready: function ready() {
    try {
        var _this2 = this;
        console.log('result-page:ready', this.hiddenAmount);
        var params = {
            receive_method: this.autoReceive ? 0 : 1,
            btn_name: this.buttonText
        };
        if (this.taskCouponList.length) {
            this.taskCouponList.forEach(function func_trir_11f726a5fd4342c7b58f144b1c1a3630(_ref2) {
                try {
                    var task_id = _ref2.task_id;
                    _this2.taskDetail.push(task_id);
                } catch (e)
                                        {
                        'use strict';
                        var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                            try {
                                JSON.stringify(k);
                                return true;
                            } catch (e) {
                                return false;
                            }
                        });
                        window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_11f726a5fd4342c7b58f144b1c1a3630@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                            stack: e.stack,
                            arguments: omegaParams
                        }) : '';
                        throw e;
                    }
            });
            params.task_detail = this.taskDetail;
        }
        this.triggerEvent('trackEvent', {
            type: 'resultPageShow',
            params: params
        });
        if (this.isAutoJump && this.buttonType !== 'share') {
            this.handleAutoJump();
        }
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('ready@@../../../../src/components/pages/result-page.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}
});
var currentOption = global.currentOption;
exports.default = (0, _optionProcessor2.default)(currentOption, "component", "", "result-page359e9e68", {}, // @ts-ignore
{}, // @ts-ignore
{
  'coupon': (0, _optionProcessor.getComponent)(require("../common/coupon.mpx?component=true&componentId=coupon505df63e")),
  'coupon-large': (0, _optionProcessor.getComponent)(require("../common/coupon-large.mpx?component=true&componentId=coupon-large86d82da8")),
  'mpx-button': (0, _optionProcessor.getComponent)(require("builtInComponent.vue!=!../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-button.vue?component=true"), {
    __mpxBuiltIn: true
  }),
  'mpx-view': (0, _optionProcessor.getComponent)(require("builtInComponent.vue!=!../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?component=true"), {
    __mpxBuiltIn: true
  })
}, undefined, {}, undefined, (0, _optionProcessor.getWxsMixin)(wxsModules));